import Vue from 'vue'
import { AclInstaller, AclCreate, AclRule } from 'vue-acl'
import router from '@/router'

Vue.use(AclInstaller)

let initialRole = 'subscriber'

const userInfo = JSON.parse(localStorage.getItem('user'))
if (userInfo && userInfo.role) initialRole = userInfo.role

export default new AclCreate({
  initial  : initialRole,
  notfound : '/pages/not-authorized',
  router,
  acceptLocalRules : true,
  globalRules: {
    admin  : new AclRule('admin').generate(),
    public: new AclRule('public').or('admin').generate(),
    subscriber : new AclRule('subscriber').or('admin').generate(),
    login: new AclRule('login').generate(),
  }
})
